export default {
  id: null,
  nome: null,
  url: null,
  icon: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/linkmodel.js